/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertNoteTemplate } from './InternalApiAlertNoteTemplate';
import {
    InternalApiAlertNoteTemplateFromJSON,
    InternalApiAlertNoteTemplateFromJSONTyped,
    InternalApiAlertNoteTemplateToJSON,
    InternalApiAlertNoteTemplateToJSONTyped,
} from './InternalApiAlertNoteTemplate';

/**
 * 
 * @export
 * @interface InternalApiAlertNoteTemplatePage
 */
export interface InternalApiAlertNoteTemplatePage {
    /**
     * 
     * @type {Array<InternalApiAlertNoteTemplate>}
     * @memberof InternalApiAlertNoteTemplatePage
     */
    content: Array<InternalApiAlertNoteTemplate>;
    /**
     * Current page number (zero-based)
     * @type {number}
     * @memberof InternalApiAlertNoteTemplatePage
     */
    number: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof InternalApiAlertNoteTemplatePage
     */
    size: number;
    /**
     * Total number of items across all pages
     * @type {number}
     * @memberof InternalApiAlertNoteTemplatePage
     */
    total: number;
}

/**
 * Check if a given object implements the InternalApiAlertNoteTemplatePage interface.
 */
export function instanceOfInternalApiAlertNoteTemplatePage(value: object): value is InternalApiAlertNoteTemplatePage {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function InternalApiAlertNoteTemplatePageFromJSON(json: any): InternalApiAlertNoteTemplatePage {
    return InternalApiAlertNoteTemplatePageFromJSONTyped(json, false);
}

export function InternalApiAlertNoteTemplatePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertNoteTemplatePage {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(InternalApiAlertNoteTemplateFromJSON)),
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
    };
}

export function InternalApiAlertNoteTemplatePageToJSON(json: any): InternalApiAlertNoteTemplatePage {
    return InternalApiAlertNoteTemplatePageToJSONTyped(json, false);
}

export function InternalApiAlertNoteTemplatePageToJSONTyped(value?: InternalApiAlertNoteTemplatePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(InternalApiAlertNoteTemplateToJSON)),
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
    };
}

